import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "manualVolume", "volumeField" ]

  connect() {
    this.toggleVolumeField();
  }

  toggleVolumeField(event){
    const checkbox = event ? event.target : this.manualVolumeTarget;

    if (checkbox.checked) {
      this.volumeFieldTarget.classList.remove("d-none");
    } else {
      this.volumeFieldTarget.classList.add("d-none");
    }
  }
}
